import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function CustomDatePicker() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const renderMonthButtons = () => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1; // Month is 0-based

    const months = Array.from({ length: currentMonth }, (_, index) => index + 1);
    const years = Array.from({ length: currentYear - 2022 + 1 }, (_, index) => 2022 + index); // Assuming the product was installed in 2022

    return (
      <div className="month-year-buttons">
        {months.map((month) => (
          <button key={month} onClick={() => handleMonthClick(month)}>
            {monthNames[month - 1]}
          </button>
        ))}
        {years.map((year) => (
          <button key={year} onClick={() => handleYearClick(year)}>
            {year}
          </button>
        ))}
      </div>
    );
  };

  const handleMonthClick = (selectedMonth) => {
    // Handle month selection logic here
    console.log(`Selected month: ${selectedMonth}`);
  };

  const handleYearClick = (selectedYear) => {
    // Handle year selection logic here
    console.log(`Selected year: ${selectedYear}`);
  };

  return (
    <div>
      {renderMonthButtons()}
      <DatePicker
        selected={startDate}
        onChange={handleDateChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        inline
      />
    </div>
  );
}

export default CustomDatePicker;
